import {
  FLIGHTS_DAYVIEW_RENDERED,
  CONFIG_SCREEN_LANDING,
  BOOKING_PANEL_LOADED,
} from '@web-platform/shared-universal-constants/src/redux/actions/render';

import type { Action } from '@web-platform/shared-universal-types/src/redux/actions/actions-shared-types';
import type { EventsState } from '@web-platform/shared-universal-types/src/redux/state/appInitial/user/events';

export default function (state: EventsState = {}, action: Action) {
  switch (action.type) {
    case CONFIG_SCREEN_LANDING: {
      return { ...state, configPageId: action.payload.configPageId };
    }

    case BOOKING_PANEL_LOADED:
    case FLIGHTS_DAYVIEW_RENDERED: {
      return {
        ...state,
        // only update the searchId if not already set (there is no way for the search to change)
        //  - note that we only track using the first value, see: apps/banana-webapp/src/middleware/tracking/flightsDayview/trackSearch.js
        //    - i.e. clients.Search emitted once using the first searchId
        //  - further background: https://skyscanner.atlassian.net/wiki/spaces/IRN/pages/195481096/Acorn+Linking+searchGuid+to+Config+events
        searchId: state.searchId || action.payload.searchId,
      };
    }

    default:
      return state;
  }
}
export const get = (state: EventsState) => state;
